/// <amd-module name="VSSUI/Components/Header/HeaderBackButton" />
import * as React from "react";

import { IHeaderBackButtonProps } from "./Header.Props";

import { ScreenSize } from "VSS/Core/Util/Screen";

import { Button } from "VSSUI/Button";
import { IconSize } from "VSSUI/Icon";
import * as Resources from "VSSUI/Resources.Page";
import { css } from "VSSUI/Util";
import { ScreenSizeObserver } from "VSSUI/Utilities/ScreenSize";

export function HeaderBackButton(props: IHeaderBackButtonProps) {
    const { buttonProps } = props;

    return (
        <ScreenSizeObserver>
            {(screenSizeProps: { screenSize: ScreenSize }) => {
                const smallScreen = screenSizeProps.screenSize === ScreenSize.xsmall;

                return (
                    <Button
                        ariaLabel={Resources.Back}
                        iconProps={{
                            iconName: "Back",
                            size: smallScreen ? IconSize.small : undefined
                        }}
                        subtle={true}
                        {...buttonProps}
                        text={smallScreen ? (buttonProps.text ? buttonProps.text : Resources.Back) : undefined}
                        className={css(buttonProps.className, "bolt-header-back-button justify-end")}
                    />
                );
            }}
        </ScreenSizeObserver>
    );
}
